import React, { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import DefaultModuleLayout from './DefaultModuleLayout';

function MaintenanceToolsLayout() {
    useEffect(() => {
        localStorage.setItem('selectedModule', 'Maintenance Tools');
    }, []);

    return (
        <DefaultModuleLayout>
            <div className="w-full bg-light-grey overflow-x-hidden overflow-y-scroll h-[calc(100vh-64px)]">
                <Outlet />
            </div>
        </DefaultModuleLayout>
    );
}

export default MaintenanceToolsLayout;
